import firebase from "../firebase";
import { isEmpty } from "react-redux-firebase";
const db = firebase.firestore();

export const fetchCargas = (perfil) => {
  return function (dispatch) {
    if (!isEmpty(perfil)) {
      //var fecha = (new Date().getTime() - (86400000 * 5)); //fecha toma el valor de 5 dias atras
      //.where("fecha", ">", fecha)
      db.collection("empresas")
        .doc(perfil.empresa)
        .collection("cargas")
        .orderBy("fecha", "asc")
        .onSnapshot(function (querySnapshot) {
          let items = [];
          querySnapshot.forEach(function (doc) {
            let item = doc.data();
            item.doc = doc;
            item.id = doc.id;
            items.push(item);
          });
          dispatch(add(items));
        });
    }
  };
};

const add = (item) => ({
  type: "ADD_CARGA",
  ...item,
});

const edit = (item) => ({
  type: "EDIT_CARGA",
  ...item,
});

const del = (item) => ({
  type: "DELETE_CARGA",
  ...item,
});
